import React from 'react';
import {Breadcrumb} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import styled from 'styled-components';

type MypageBreadcrumbProps = {
  children: React.ReactNode,
};

const MypageBreadcrumb = ({children}: MypageBreadcrumbProps) => (
  <Container>
    <StyledBreadCrumb>{children}</StyledBreadCrumb>
  </Container>
);

type BreadcrumbItemLinkProps = {
  to: string,
  children: React.ReactNode,
};

const BreadcrumbItemLink = ({to, children}: BreadcrumbItemLinkProps) => (
  <React.Fragment>
    <Breadcrumb.Section link as={Link} to={to}>
      {children}
    </Breadcrumb.Section>
    <Breadcrumb.Divider />
  </React.Fragment>
);

type BreadcrumbItemProps = {
  children: React.ReactNode,
};

const BreadcrumbItem = ({children}: BreadcrumbItemProps) => (
  <Breadcrumb.Section>{children}</Breadcrumb.Section>
);

MypageBreadcrumb.ItemLink = BreadcrumbItemLink;
MypageBreadcrumb.Item = BreadcrumbItem;

export {MypageBreadcrumb as Breadcrumb};

const Container = styled.div`
  text-align: left;
`;

const StyledBreadCrumb = styled(Breadcrumb)`
  &&& {
    background-color: white;
  }
`;
